/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PdfShareLinkDetailDto } from './pdfShareLinkDetailDto';
import { InspectionItemDto } from './inspectionItemDto';


export interface InspectionPdfDetailDto { 
    id: string;
    s3Key: string;
    lastGenerated: string;
    inspectionPdfType: InspectionPdfDetailDto.InspectionPdfTypeEnum;
    inspection: InspectionItemDto;
    presignedUrl?: string;
    inspectionVersion: number;
    pdfShareLink?: PdfShareLinkDetailDto;
    contractorId?: string;
    excludeFinishedRepairTasks: boolean;
}
export namespace InspectionPdfDetailDto {
    export type InspectionPdfTypeEnum = 'SHORTLIST' | 'LONGLIST' | 'COVERSHEET' | 'BUILDING_EQUIPMENTS' | 'CERTIFICATE_SHEET' | 'REPAIR_TASK_SHORTLIST' | 'BUILDING_EQUIPMENTS_SCHLOSS' | 'CERTIFICATE_SHEET_SCHLOSS' | 'OBJECT_SAFETY_REPORT' | 'SCHADSTELLENPLAN' | 'OBJECT_SAFETY_LIST';
    export const InspectionPdfTypeEnum = {
        Shortlist: 'SHORTLIST' as InspectionPdfTypeEnum,
        Longlist: 'LONGLIST' as InspectionPdfTypeEnum,
        Coversheet: 'COVERSHEET' as InspectionPdfTypeEnum,
        BuildingEquipments: 'BUILDING_EQUIPMENTS' as InspectionPdfTypeEnum,
        CertificateSheet: 'CERTIFICATE_SHEET' as InspectionPdfTypeEnum,
        RepairTaskShortlist: 'REPAIR_TASK_SHORTLIST' as InspectionPdfTypeEnum,
        BuildingEquipmentsSchloss: 'BUILDING_EQUIPMENTS_SCHLOSS' as InspectionPdfTypeEnum,
        CertificateSheetSchloss: 'CERTIFICATE_SHEET_SCHLOSS' as InspectionPdfTypeEnum,
        ObjectSafetyReport: 'OBJECT_SAFETY_REPORT' as InspectionPdfTypeEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as InspectionPdfTypeEnum,
        ObjectSafetyList: 'OBJECT_SAFETY_LIST' as InspectionPdfTypeEnum
    };
}


